import { render, staticRenderFns } from "./DebitDetails.vue?vue&type=template&id=39c78a25"
import script from "./DebitDetails.vue?vue&type=script&lang=js"
export * from "./DebitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports